/**
 * accordion.js — Shared accordion toggle logic (event delegation)
 * Used by: Advantages, Product details, FAQ
 *
 * Markup contract:
 *   [data-accordion]          — accordion item root
 *   [data-accordion-toggle]   — clickable header (button)
 *   next sibling of toggle    — collapsible content panel
 */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;

    var content = toggle.nextElementSibling;
    if (!content) return;

    var expanded = toggle.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      content.style.height = content.scrollHeight + 'px';
      content.offsetHeight; // force reflow
      content.style.height = '0';
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      content.style.height = content.scrollHeight + 'px';
      content.addEventListener('transitionend', function handler() {
        content.removeEventListener('transitionend', handler);
        if (toggle.getAttribute('aria-expanded') === 'true') {
          content.style.height = '';
        }
      });
    }
  });
})();
